import React from 'react';
import { GenericListPage } from '../../../components/generic';
import { useServiceTypes, ServiceType } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<ServiceType>
      useData={useServiceTypes}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
